export default __webpack_public_path__ + "static/media/reelwood...d8346ecd.png";